import React from 'react';

interface IProps {
    value?: number | string;
}

const PriceLabel = ({
    value,
}: IProps) => {
    if (typeof value === 'object') {
        return (
            <span>N/A</span>
        );
    }

    if (typeof value === 'string' && value.length > 0) {
        return (
            <span>{value}</span>
        );
    }

    if (typeof value === 'string' && !value) {
        return (
            <span>N/A</span>
        );
    }

    if (typeof value === 'number') {
        return (
            <span>${value}</span>
        );
    }

    return (
        null
    );
};

export default PriceLabel;
